import React from 'react';
import { Chip, ChipColor } from '../../../../../components/Chip';
import { RedactedEntry } from '../RedactedEntry';

interface PropTypes {
  label: string;
  redacted?: boolean;
  value?: string;
  valueLabel?: string;
}

export function Entry(props: PropTypes) {
  if (props.value == null || props.value == '') return null;

  return (
    <div className='d-flex align-items-center'>
      <span className='me-auto text-nowrap'>{props.label}</span>
      {props.redacted ? (
        <RedactedEntry label={props.value} />
      ) : (
        <Chip className='ms-3' color={ChipColor.Gray} truncate>
          {props.value}
        </Chip>
      )}
    </div>
  );
}
